module.exports = __webpack_public_path__ + "img/funding-requests.79521378.svg";